export const SystemClassifierUrl = {
  SEARCH:
    '/system-classifiers{?page,size,sort*,code,name,description,userManaged}',
  SYSTEM_CLASSIFIER: '/system-classifiers{/id}',
} as const;
